import React from 'react';

import { className, Heading, Text } from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';
import { useTranslate } from 'soluble-gatsby-source';
import style from './style.module.scss'

export default function CardEventComponent({
    title,
    venue,
    text,
    registerUrl,
    viewUrl,
    isFuture,
    dateLarge,
    timeLarge
}) {
    const translation = useTranslate();

    return (
        <div {...className(`${style.wrapper} pt-4 pl-2 pr-2 pb-4 pt-lg-5 pl-lg-5 pr-lg-5 pb-lg-4 d-lg-flex flex-lg-column justify-content-lg-between`)}>
            <div>
                <div {...className('d-flex justify-content-between mb-2')}>
                    <Text
                        tag="span"
                        className="body text-uppercase font-weight-bold"
                    >
                        {dateLarge}
                    </Text>
                    <Text
                        tag="span"
                        className="body font-weight-bold"
                    >
                        {timeLarge}
                    </Text>
                </div>
                <Heading
                    tag="h4"
                    className="h3 font-weight-bold"
                    mb={{ xs: 2 }}
                >
                    {title}
                </Heading>
                {venue ? (
                    <Text
                        tag="p"
                        mb={{ xs: 2 }}
                        className="body font-weight-bold"
                    >
                        {venue}
                    </Text>
                ) : null}
                <Text
                    tag="div"
                    className="body"
                    mb={{ xs: 3 }}
                >
                    {text}
                </Text>
            </div>
            <div>
                <ButtonComponent
                    button={{
                        block: true,
                        detached: true,
                        externalLink: isFuture && registerUrl ? registerUrl : (viewUrl ? viewUrl : registerUrl),
                        label: translation[`events-section.event.${isFuture ? 'next' : 'past'}.cta`].text,
                        target: '_blank'
                    }}
                />
            </div>
        </div>
    )
}
